export default {
  install: function (Vue) {
    /**
     * @param {{
     *  message: string,
     *  type: 'success' | 'error',
     *  delay?: number,
     *  timeout?: number }} options
     */
    Vue.prototype.$notify = function ({
      message,
      type = 'success',
      delay = 0,
      timeout = 3000
    }) {
      window.dispatchEvent(
        new CustomEvent('notify', {
          detail: {
            message,
            type,
            delay,
            timeout
          }
        })
      )
    }
  }
}
